import React from 'react';
import { LOGO, APP } from '../../config/appConfig';
import { useWallet } from '../../context/WalletContext';
import AccountChip from '../wallet/AccountChip';

export default function Header() {
  const { account, isCorrectNetwork } = useWallet();
  return (
    <header className="app-header">
      <div className="brand">
        <img src={LOGO} alt="logo" />
        <div>
          <div className="name">{APP.name}</div>
          <div className="tag">{APP.tagline}</div>
        </div>
      </div>
      <div className="row gap-6">
        {account && (
          <div className={`net-dot ${isCorrectNetwork ? '' : 'bad'}`}>
            <span className="dot" />
            {isCorrectNetwork ? 'Online' : 'Wrong Net'}
          </div>
        )}
        <AccountChip />
      </div>
    </header>
  );
}
